import { TagResponse } from '@/api/lib/category';

export function createTagSuggestions(tags: TagResponse[]) {
  if (!tags || tags.length === 0) {
    return null;
  }

  const tagSuggestions = tags.map((tag) => ({ id: tag.id, text: tag.name }));
  return [
    {
      values: tagSuggestions
    }
  ];
}

export function createSimilarTagSuggestions(tags: TagResponse[]) {
  if (!tags || tags.length === 0) {
    return null;
  }

  return tags.map((tag) => ({ id: tag.id, name: tag.name }));
}
